import noop from 'utils/noop';
import {
  LifetimeLimitInput,
  SimultaneousLimitInput,
} from 'modules/workflowNodeEditors/components/StartNodeEditor/EntranceLimitForm';

export interface EntranceLimitFormProps {
  /** The lifetime limit */
  lifetimeLimit: number | null;
  /** The simultaneous limit */
  simultaneousLimit: number | null;
  /** validation error message for simultaneous limit input */
  simultaneousLimitError?: string;
  /** validation error message for lifetime limit input */
  lifetimeLimitError?: string;
  /** Callback triggered when the lifetime limit is changed */
  onLifetimeLimitUpdate?: (lifetimeLimit: number | null) => void;
  /** Callback triggered when the simultaneous limit is changed */
  onSimultaneousLimitUpdate?: (simultaneousLimit: number | null) => void;
  /** is tile editor read only */
  isReadOnly?: boolean;
}

/**
 * NOTE: No longer used after StartTileRefresh is GA
 */
export const EntranceLimitForm = ({
  lifetimeLimit,
  simultaneousLimit,
  simultaneousLimitError,
  lifetimeLimitError,
  isReadOnly = false,
  // callbacks
  onLifetimeLimitUpdate = noop,
  onSimultaneousLimitUpdate = noop,
}: EntranceLimitFormProps) => {
  // New entrance form layout
  return (
    <>
      <LifetimeLimitInput
        onLifetimeLimitUpdate={onLifetimeLimitUpdate}
        lifetimeLimit={lifetimeLimit}
        error={lifetimeLimitError}
        isReadOnly={isReadOnly}
      />
      <SimultaneousLimitInput
        onSimultaneousLimitUpdate={onSimultaneousLimitUpdate}
        simultaneousLimit={simultaneousLimit}
        error={simultaneousLimitError}
        isReadOnly={isReadOnly}
      />
    </>
  );
};

export default EntranceLimitForm;
